import { render, staticRenderFns } from "./TestingToolsToolbarButton.vue?vue&type=template&id=54f1b1ce&"
import script from "./TestingToolsToolbarButton.vue?vue&type=script&lang=js&"
export * from "./TestingToolsToolbarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports